module.exports = __webpack_public_path__ + "592b2b247c661f58231b4fe82ec62f31.svg";